document.querySelectorAll('.video-image-gallery-section').forEach((section) => {

    const galleryPopups = section.querySelectorAll('.gallery-popup-overlay');



    /* =========================
       STOP VIDEOS
    ========================== */

    function stopPopupVideos(popup){

        const videos = popup.querySelectorAll('video');

        videos.forEach((video) => {

            video.pause();
            video.currentTime = 0;

        });

    }



    /* =========================
       PLAY VIDEOS
    ========================== */

    function playPopupVideos(popup){

        const videos = popup.querySelectorAll('video');

        videos.forEach((video) => {

            video.play();

        });

    }



    /* =========================
       MAIN GALLERY
    ========================== */

    const mainGalleryButtons = section.querySelectorAll(
        '.gallery-main .gallery-box'
    );

    mainGalleryButtons.forEach((button, index) => {

        button.addEventListener('click', (e) => {

            e.stopPropagation();

            if(galleryPopups[index]){

                galleryPopups[index].classList.add('active');

                playPopupVideos(galleryPopups[index]);

                document.body.style.overflow = 'hidden';

            }

        });

    });



    /* =========================
       LIGHTBOX GALLERY
    ========================== */

    const lightboxGalleryButtons = section.querySelectorAll(
        '.pop-gallery-video-image .gallery-box'
    );

    lightboxGalleryButtons.forEach((button, index) => {

        button.addEventListener('click', (e) => {

            e.stopPropagation();

            if(galleryPopups[index]){

                galleryPopups[index].classList.add('active');

                playPopupVideos(galleryPopups[index]);

                document.body.style.overflow = 'hidden';

            }

        });

    });



    /* =========================
       LIGHTBOX OPEN
    ========================== */

    const lightboxButton = section.querySelector('.lightbox button');
    const lightboxPopup = section.querySelector('.lightbox-popup-overlay');

    if(lightboxButton && lightboxPopup){

        lightboxButton.addEventListener('click', () => {

            lightboxPopup.classList.add('active');

            document.body.style.overflow = 'hidden';

        });

    }



    /* =========================
       CLOSE POPUPS
    ========================== */

    const allPopups = section.querySelectorAll(
        '.gallery-popup-overlay, .lightbox-popup-overlay'
    );

    allPopups.forEach((popup) => {

        const closeBtn = popup.querySelector(
            '.gallery-popup-close, .lightbox-popup-close'
        );



        /* CLOSE BUTTON */

        if(closeBtn){

            closeBtn.addEventListener('click', () => {

                popup.classList.remove('active');

                stopPopupVideos(popup);

                const activePopup = section.querySelector(
                    '.gallery-popup-overlay.active, .lightbox-popup-overlay.active'
                );

                if(!activePopup){

                    document.body.style.overflow = '';

                }

            });

        }



        /* OVERLAY CLICK */

        popup.addEventListener('click', (e) => {

            if(e.target === popup){

                popup.classList.remove('active');

                stopPopupVideos(popup);

                const activePopup = section.querySelector(
                    '.gallery-popup-overlay.active, .lightbox-popup-overlay.active'
                );

                if(!activePopup){

                    document.body.style.overflow = '';

                }

            }

        });

    });

});


 var swiper = new Swiper(".video-gallery-slider", {
      slidesPerView: 1.2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
});